<div id="subject-section" class="py-5">
  <div class="container px-5">
    <h3 class="capitalize mb-10 text-[#010128] font-bold text-2xl text-center xl:text-6xl lg:text-5xl md:text-4xl">Why
      Students Trust Our Flashcards
    </h3>

    <div class="flex flex-wrap justify-center">
      @for (sub of subjects; track $index) {
      <div class="w-full p-3 md:w-1/2 lg:w-1/3 ">
        <app-static-why-love [subject]="sub" />
      </div>
      }
    </div>
  </div>
</div>